<template>
  <label :class="['pretty', ...wrapperClasses]">
    <input
      type="radio"
      :name="name"
      :value="value"
      :checked="modelValue === value"
      :disabled="disabled"
      @change="$emit('update:modelValue', value)"
    />
    <div :class="['state', stateClass]">
      <label><slot /></label>
    </div>
  </label>
</template>

<script>
export default {
  name: 'p-radio',
  props: {
    modelValue: { default: null },
    value: { default: null },
    name: { type: String, default: '' },
    color: { type: String, default: 'default' },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  computed: {
    wrapperClasses () {
      return Array.from(this.$el?.parentElement?.classList || [])
        .filter(c => ['p-default','p-curve','p-smooth','p-bigger','p-locked','p-round'].includes(c))
    },
    stateClass () {
      return this.color !== 'default' ? `p-${this.color}` : ''
    }
  }
}
</script>
